import React, { useCallback } from 'react'
import { Col, Row } from 'react-bootstrap'
import { State, useState } from '@hookstate/core'
import { useLanguageState } from '../../globalStates/LanguageState'
import { Organization, PrintCatalog } from '../../globalStates/ExhibitorDataState'
import { fieldNameByLang, getElementFieldValueWithLanguage, makeSetHandlerWithLanguage, useLanguageSwitch } from '../../utils/Language'
import TextAreaField from '../../components/Field/TextArea'
import Section from '../../components/Section'
import LanguageSwitch from '../languageSwitch'
import ToggleSwitchField from '../../components/Field/ToggleSwitchField'

interface CompanyDescriptionSectionProps {
    printCatalogState: State<PrintCatalog>
    organizationState: State<Organization>
    readOnly: boolean
}

const CompanyDescriptionSection: React.FC<CompanyDescriptionSectionProps> = ({ printCatalogState, organizationState, readOnly }) => {
    const branding = useLanguageState().getStrings()
    const printCatalog = useState(printCatalogState)
    const isMonoLingual = branding.configuration.monoLingual ? 'De' : 'En'
    const { currentLanguage, onChangeLanguageHandler } = useLanguageSwitch(isMonoLingual);
    const onChangeDescriptionImported = useCallback(() => {
        printCatalog.descriptionImported.set(!printCatalog.descriptionImported.get())
        if (printCatalog.descriptionImported.get()) {
            printCatalog.description.set(organizationState.teaser.get())
            printCatalog.descriptionDe.set(organizationState.teaserDe.get())
        }
    }, [organizationState, printCatalog])

    return (
        <Section title={branding.configuration.printPage.sctCompanyDescription.lblSectionCompanyDescription}>
            <Row>
                <Col>
                    <ToggleSwitchField
                        name="copyCompanyDescription"
                        label={branding.configuration.printPage.lblCopyData}
                        value={printCatalog.descriptionImported.get()}
                        readonly={readOnly}
                        onChange={onChangeDescriptionImported}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <LanguageSwitch
                        id={`print_language_switch`}
                        name={`print_languages`}
                        value={currentLanguage}
                        onChange={onChangeLanguageHandler}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <TextAreaField
                        name={fieldNameByLang("description", currentLanguage)}
                        label={branding.configuration.printPage.sctCompanyDescription.lblCompanyPortrait}
                        placeholder={branding.configuration.printPage.sctCompanyDescription.hntCompanyPortrait}
                        value={getElementFieldValueWithLanguage(printCatalog, "description", currentLanguage)}
                        onChange={makeSetHandlerWithLanguage(printCatalog, 'description', currentLanguage)}
                        limit={400}
                        style={{ height: '100px' }}
                        readonly={printCatalog.descriptionImported.get() || readOnly}
                    />
                </Col>
            </Row>
        </Section>
    );
}

export default CompanyDescriptionSection
